import { ThemeProvider as NextThemesProvider } from "next-themes";
import { type ReactNode } from "react";
import { THEME_STORAGE_KEY } from "~/constants";

interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      storageKey={THEME_STORAGE_KEY}
    >
      {children}
    </NextThemesProvider>
  );
}
